@if (loading) {
  <app-preloader></app-preloader>
}
@if (!loading) {
  <form class="form form_crm mb-4" [formGroup]="form" novalidate (submit)="saveFiles()">
    <app-material-input-dropzone formControlName="files"
      [hasComments]="false">
    </app-material-input-dropzone>
    <div class="text-center">
      <button [disabled]="!form.value.files.length" type="submit" class="button button_main">
        Сохранить загруженные изображения
      </button>
    </div>
  </form>
}
